module.exports = __webpack_public_path__ + "img/symphony_799_charcoal.07734761.jpg";